<template>
  <!-- // 默认一页10条数据 -->
  <div class="pag">
    <!-- <a-pagination
      show-quick-jumper
      :default-current="2"
      :total="200"
      @change="onChange"
      :show-total="(showTotal) => `共${showTotal / 10}页`"
    /> -->
    <!-- <a-config-provider :locale="locale">
      <a-pagination
        v-model="current1"
        show-quick-jumper
        :default-current="1"
        :total="showTotal"
        @change="onChange"
        :show-total="(showTotal) => `共${showTotal / 10}页`"
      />
    </a-config-provider> -->
    <a-pagination show-quick-jumper :current="pageNumber" :default-current="1" :total="showTotal" @change="onChange" />
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; // 汉化

export default {
  props: ['current'],
  data() {
    return {
      pageNumber:1,
      pagination: {},
      locale: zhCN, //区域：中国
      showTotal:10, //数据总条数
    };
  },
    computed: {
        current1:{
          get (){
            return this.current;
          },
          set(){}
        }
    },
  methods: {
    // 页面切换时间
    onChange(pageNumber) {
      this.$emit("passpage",pageNumber)
    },

  },
   created() {
    this.pageNumber = parseInt(sessionStorage.getItem("pageNumber"))
    this.showTotal = parseInt(sessionStorage.getItem("showTotal"))
  },
  // mounted(){
  //   this.pageNumber = parseInt(sessionStorage.getItem("pageNumber"))
  // }
};
</script>
<style lang="less" scoped>
.pag {
  // border: 1px solid #000;
  position: absolute;
  // // transform: translate(-50%, -50%);
  // display: flex;
  width: 79%;
  // height: 10%;
  padding-left: 14%;
  
  // justify-content: center;
  // align-items: flex-end;
  // right: 0;
  bottom: 1%;
  // margin-top: 1%;
}

// @media (max-width: 1025px) {
//   .pag {
//     transform: translateX(-50%);
//   }
// }
// @media (max-width: 1367px) {
//   .pag {
//     transform: translateX(-30%);
//   }
// }

/deep/ .ant-pagination-item-active a {
  color: #fff !important;
  background: #2faeb6;
  // border: 1px solid #2faeb6 !important;
  border-radius: 4px;
}
/deep/ .ant-pagination-item:hover {
  border: 1px solid #2faeb6;
}
/deep/ .ant-pagination-item-active {
  font-weight: 500;
  background: #2faeb6;
  border-color: #2faeb6;
}
/deep/ .ant-pagination-item:hover a {
  color: #2faeb6;
}
/deep/ .ant-pagination-prev:hover .ant-pagination-item-link {
  color: #2faeb6;
  border-color: #2faeb6;
}
/deep/ .ant-pagination-next:hover .ant-pagination-item-link {
  color: #2faeb6;
  border-color: #2faeb6;
}
/deep/ .ant-pagination-options-quick-jumper input:hover {
  color: #2faeb6;
}
/deep/
  .ant-pagination-jump-next
  .ant-pagination-item-container
  .ant-pagination-item-link-icon {
  color: #2faeb6;
}
/deep/
  .ant-pagination-jump-prev
  .ant-pagination-item-container
  .ant-pagination-item-link-icon {
  color: #2faeb6;
}
/deep/ .ant-pagination-options-quick-jumper input:hover {
  border-color: #2faeb6;
}
</style>